import { useEffect, useState } from "react";
import { Numeral } from "../numeral/Numeral";

export const conditions = [
  { title: "Monto Aprobado:", number: 200000 },
  { title: "Fecha Aprobación:", value: "Dia / Mes / Año" },
  { title: "Plazo Aprobado (días):", value: "x" },
  {
    title: "Interés Corriente (E.A):",
    value:
      "El Interés Corriente o Remuneratorio consiste en el porcentaje sobre el valor prestado que recibirá Galilea durante el tiempo en que el dinero esté en tu poder. Galilea cobra por interés remuneratorio el (%)Efectivo Anual, este porcentaje es inferior a la tasa máxima legal.",
  },
  {
    title: "Interés Moratorio:",
    value:
      "El interés moratorio consiste en la indemnización que le pagas a Galilea por no cumplir con tu obligación a tiempo. La tasa de interés moratorio en Colombia varía mes a mes, sin embargo, por parte de Galilea no se cobrará una tasa de interés moratorio que exceda una y media (1.5) veces la tasa de interés bancario corriente. En este caso, la tasa máxima vigente a la fecha de crédito es: XX% Efectivo Anual para el mes de XX de 20XX.",
  },
  { title: "Fecha de vencimiento:", value: "Dia / Mes / Año" },
  { title: "Firma Electrónica (Opcional):", number: 145000 },
  { title: "Descuento Firma electrónica:", number: 0 },
  { title: "Total a pagar:", number: 276000 },
];

export const getConditions = (creditUser, dctoFirmaElectronica, firmaElectronica, total) => {
  let tmlv = localStorage.getItem("tmlv");
  if (tmlv) {
    tmlv = JSON.parse(tmlv);
  } else {
    tmlv = [];
  }
  let dateTmlv = tmlv[0]?.date;
  let tasaTmlv = tmlv[0]?.rate;

  let conditions = [
    { title: "Monto Aprobado:", number: creditUser.approvedQuota },
    { title: "Fecha Aprobación:", value: `${creditUser?.approvedDate}` },
    { title: "Plazo Aprobado (días):", value: creditUser?.termInDays },
    {
      title: "Interés Corriente (E.A):",
      value:
        `El Interés Corriente o Remuneratorio consiste en el porcentaje sobre el valor prestado que recibirá Galilea durante el tiempo en que el dinero esté en tu poder.
        Galilea cobra por interés remuneratorio el ${localStorage.getItem('currentInterestTea') ?? 25}(%)Efectivo Anual, este porcentaje es inferior a la tasa máxima legal. `,
    },
    {
      title: "Interés Moratorio:",
      value:
        `El interés moratorio consiste en la indemnización que le pagas a Galilea por no cumplir con tu obligación a tiempo.
       La tasa de interés moratorio en Colombia varía mes a mes, sin embargo,
        por parte de Galilea no se cobrará una tasa de interés moratorio que exceda una y media (1.5) veces la tasa de interés bancario corriente.
         En este caso, la tasa máxima vigente a la fecha de crédito es: ${tasaTmlv}% Efectivo Anual para el mes de ${dateTmlv}.`,
    },
    { title: "Fecha de vencimiento:", value: `${creditUser?.paydayLimit}` },
    { title: "Firma Electrónica (Opcional):", number: firmaElectronica},
    { title: "Descuento Firma electrónica:", number: dctoFirmaElectronica === firmaElectronica ? 0 : dctoFirmaElectronica},
    { title: "Total a pagar:", number: total},
  ];
  return conditions;
}

export const requirements = [
  "1.	Es mayor de 18 años.",
  "2.	Tiene un número celular y correo electrónico de su propiedad.",
  "3.	Tiene una cuenta bancaria a su nombre.",
  "4.	Vive en Colombia.",
];

export const documents = [
  "1.	Fotocopia cédula de ciudadanía.",
  "2.	Certificado laboral no mayor a 30 días.",
  "3.	Últimos 3 desprendibles de pago de nómina.",
  "4.	Certificado de cuenta bancaria no mayor a 30 días.",
  "5.	Contrato de crédito debidamente firmado, la firma la debe incorporar en todas las páginas del documento.",
  "6.	Pagaré y carta de instrucciones debidamente firmadas.",
  "7.	Documento de aceptación de los términos y condiciones generales del servicio debidamente firmado.",
  "8.	Documento de aceptación de la Política de Privacidad y Tratamiento de datos debidamente firmado y autenticado ante Notaría.",
];

export const authorizations = [
  "4.1.	Realizar consultas, verificaciones, reportes, divulgación y procesamiento de información sobre el estado de su endeudamiento y el cumplimiento de los compromisos comerciales y financieros. El Usuario como deudor autoriza expresamente a Galilea para enviar el aviso previo al reporte a las centrales de riesgos, a través de correo electrónico, teléfono, celular, correo física, SMS, WhatsApp o cualquier otro medio conocido o por conocer. ",
  "4.2.	Realizar consultas, revisión o solicitud de información en bases de datos legalmente autorizadas para desentrañar información referente a sus hábitos de pago, información crediticia y comercial, información personal, ingresos, salarios, pagos a seguridad social y demás información necesaria para el conocimiento del cliente. ",
  "4.3.	Contratar con terceros localizados en Colombia o en el extranjero, servicios relacionados con el procesamiento de datos, transmisión y almacenamiento de órdenes e información, para su utilización a escala nacional o internacional. Así mismo, manifiestan que conocen que Galilea no realiza transferencia o transmisión de datos personales a países que no tengan una protección igual o superior a la Colombiana.",
  "4.4.	Reportar a Galilea cualquier modificación o cambio en la información suministrada en el proceso de solicitud, aprobación o desembolso del crédito o durante la vigencia de la relación comercial entre las Partes.",
  "4.5.	Autorizo a Galilea, sus aliados, filiales, matriz, cesionarios, compradores de cartera nacionales o extranjeros, a conservar, mantener, compartir, suministrar, remitir, comercializar e intercambiar entre sí toda información sobre las condiciones personales, económicas o comerciales, y mi comportamiento crediticio con el fin que me sean ofrecidos los productos y servicios propios del objeto social de Galilea o los productos y servicios que prestan los terceros en ejercicio de sus objetos sociales. En el evento en que se realice una venta de cartera o cesión a cualquier título a un tercero aliado, los efectos de la presente autorización le serán extendidos a dichos terceros en los mismos términos y condiciones, y para las mismas finalidades para las cuales autorizo el tratamiento de mis datos personales por parte de Galilea. De igual manera, en el evento que se realice una venta de cartera o cesión a cualquier título esté podrá ofrecer de manera independiente o conjunta con terceros afiliados, servicios financieros, comerciales, de seguridad social y conexos, de mercadeo y publicidad a través de cualquier medio, así como realizar campañas de promoción , beneficencia o servicio social en conjunto con terceros.",
  "4.6.	Autorizo a los operadores de la información PILA para que le haga entrega a Galilea, sus aliados, filiales, matriz, cesionarios, compradores de cartera nacionales o extranjeros, mi información relativa a ingresos y aportes a seguridad social, parafiscales y demás información necesaria. Así mismo, otorgo poder amplio y suficiente a Galilea para que reciba dicha información, cuantas veces ésta lo requiera y mientras el presente poder no se revoque por mí, mediante comunicación escrita.",
  "4.7.	Autorizo a Galilea, sus aliados, filiales, matriz, cesionarios, compradores de cartera nacionales o extranjeros, para que me contacten con fines comerciales y promocionales, ya sea sobre sus propios servicios y productos, o los de terceros con los que Galilea tenga relación comercial o alianzas. Este contacto lo podrán realizar a través de Correo electrónico, SMS, WhatsApp o cualquier medio.",
  "Así mismo, autorizo para que Galilea comparta con los comercios aliados, mi información de contacto o perfil sociodemográfico que permita emprender acciones de mercadeo para llevar productos y servicios de mi interés. Galilea podrá compartir, entre otras cosas: mi nombre, email, número de teléfono, fecha de nacimiento, dirección de residencia y datos demográficos generales, manteniendo una estricta confidencialidad de los datos financieros e información sensible.",
  "4.8.	Acepto que los términos y condiciones publicados en la página web de Galilea hacen parte integral del presente contrato y fueron aceptados por mí desde el momento de registro para la solicitud del crédito.",
  "4.9.	Acepto, autorizo y comprendo que el incumplimiento de la obligación en el tiempo indicado puede generar reportes negativos ante las Centrales de Información Crediticia, tales como pero sin limitarse, Experian (DataCredito) y TransUnion (CIFIN), así mismo, comprendo que en caso de incumplimiento debo permanecer reportado por el doble de tiempo que estuve en mora.",
];

export const expirations = [
  "●	Mora en el pago de una o más de las cuotas de capital o intereses.",
  "●	El incumplimiento de cualquier otra obligación por parte del deudor.",
  "●	Si los bienes del Usuario son embargados o perseguidos judicialmente por cualquier persona y en ejercicio de cualquier acción.",
  "●	Si el Usuario es declarado en liquidación forzosa, de carácter comercial o administrativo  admitidos a proceso concordatario o de insolvencia.",
  "●	Si la garantía que se haya otorgado para cubrir el cumplimiento de la obligación a cargo del deudor y a favor del acreedor, resultaron insuficientes o se tornaren así ́ por deterioro o depreciación, a juicio del acreedor, o si fueren perseguidas judicialmente por terceras personas.",
  "●	Si el deudor dejare de asegurar los bienes que fungen como garantía a las obligaciones.",
  "●	Si el deudor enajena, a cualquier título y sin autorización del acreedor, los bienes que garantizan el cumplimiento de las obligaciones que por este pagaré asumen.",
  "●	Si el acreedor, llegara a conocer, que recibió ́ información falsa o fraudulenta por parte del deudor, en el trámite de la solicitud, aprobación y desembolso del crédito.",
];

export const advances = [
  "1.	Gastos de cobranza, si se han causado.",
  "2.	Intereses moratorios, si se han causado.",
  "3.	Firma Electrónica, si fue adquirida por el Usuario.",
  "4.	Intereses corrientes.",
  "5.	Capital.",
];

export const collections = [
  "a.	Llamadas telefónicas con contacto directo, sin contacto o mensajes a contestador automático.",
  "b.	Envío de cartas a través de correo o telegramas.",
  "c.	Mensajería SMS.",
  "d.	Envío de correos electrónicos.",
  "e.	Notificadores.",
  "f.	Envío de mensajes a través de WhatsApp.",
];

export const personals = [
  "a)	Almacenar la información que el Usuario proporciona a Galilea en el proceso de solicitud del crédito.",
  "b)	Consultar en bases de datos internas y de terceros, la información proporcionada por el Usuario con el objetivo de establecer su nivel de riesgo.",
  "c)	Prestar los servicios ofrecidos por Galilea y aceptados en el contrato suscrito.",
  "d)	Suministrar la información a terceros con los cuales Galilea tenga relación contractual y que sea necesario entregársela para el cumplimiento del objeto contratado.",
  "e)	Efectuar las gestiones pertinentes para el desarrollo del objeto social de la compañía en lo que tiene que ver con el cumplimiento del objeto del contrato celebrado con el titular de la información.",
  "f)	Realizar comunicaciones y notificaciones en relación al crédito aprobado, invitaciones a eventos, ofrecer nuevos productos y servicios a través de diferentes campañas a través del envío de información a los medios de contacto suministrados por el titular de la información, como el envío de Short Message Service (“SMS” por sus siglas en inglés), correos electrónicos, mensajes vía WhatsApp, llamadas.",
  "g)	Gestionar trámites (solicitudes, quejas, reclamos).",
  "h)	Efectuar encuestas de satisfacción respecto de los bienes y servicios ofrecidos por Galilea.",
  "i)	Suministrar información de contacto a la fuerza comercial y/o red de distribución, telemercadeo, investigación de mercados y cualquier tercero con el cual Galilea tenga un vínculo contractual para el desarrollo de actividades de ese tipo (investigación de mercados y telemercadeo, etc) para la ejecución de las mismas.",
  "j)	Contactar al titular a través de medios telefónicos y electrónicos proporcionados por éste para realizar encuestas, estudios y/o confirmación de datos personales necesarios para la ejecución del contrato o su experiencia comercial con Galilea.",
  "k)	Contactar al titular a través de medios electrónicos – SMS o chat para el envío de noticias relacionadas con campañas de fidelización o mejora de servicio.",
  "l)	Contactar al titular a través de correo electrónico para el envío de notificación previa al reporte ante las centrales de riesgo, extractos, estados de cuenta o facturas en relación con las obligaciones derivadas del contrato celebrado entre las partes.",
  "m)	El Usuario titular autoriza a Galilea o a las personas que hagan sus veces, para que contrate con terceros localizados en Colombia o en el exterior, servicios relacionados con el procesamiento de datos, transmisión y almacenamiento de órdenes e información, para su utilización a escala nacional o internacional.",
  "n)	El Usuario titular autoriza a Galilea, a compartir su información personal con sus aliados, filiales, matrices, cesionarios, compradores de cartera, tanto nacional como extranjeras para que realicen el tratamiento de su información como responsables o encargados del tratamiento de datos personales con todas las finalidades indicadas en el presente numeral.",
  "o)	El Usuario titular autoriza a Galilea, sus aliados, filiales, matrices, cesionarios, compradores de cartera, tanto nacionales como extranjeros para mantener, compartir, suministrar, remitir, comercializar e intercambiar entre sí toda información sobre las condiciones personales, económicas y comerciales, y el comportamiento crediticio del Usuario con el fin que sean ofrecidos los productos y/o servicios propios del objeto social de Galilea o los productos y/o los servicios que prestan los terceros en ejercicio de sus objetos sociales y actividades comerciales lícitas o para propósitos legítimos de las partes definidos en este numeral.",
  "p)	El Usuario titular entiende que, en el evento que Galilea realice una venta de cartera o cesión a cualquier título a un tercero aliado, los efectos de la presente autorización le serán extendidos a dicho tercero en los mismos términos y condiciones, y para las mismas finalidades para las cuales autoriza el tratamiento de sus datos personales por parte de Galilea. De igual manera, en el evento que se realice una venta de cartera o cesión a cualquier título a un tercero aliado, éste podrá́ ofrecer, de manera independiente o conjunta con terceros afiliados, servicios financieros, comerciales, de seguridad social y conexos, de mercadeo y publicidad a través de cualquier medio, así́ como realizar campañas de promoción, beneficencia o servicio social en conjunto con terceros.",
  "q)	El Usuario titular en desarrollo de lo dispuesto en los artículos 8 y 13 de la Ley 1581 de 2021 y normas concordantes, autoriza a los operadores de información PILA para que hagan entrega a Galilea de la información relativa a sus ingresos y aportes a parafiscales. Para los efectos anteriores, otorgas poder especial, amplio y suficiente a Galilea para que reciba dicha información.",
];

export const rights = [
  "a)	Acceder en forma gratuita a los datos proporcionados que hayan sido objeto de tratamiento.",
  "b)	Solicitar la actualización y rectificación de su información frente a datos parciales, inexactos, incompletos, fraccionados, que induzcan a error, o a aquellos cuyo tratamiento esté prohibido o no haya sido autorizado.",
  "c)	Solicitar prueba de la autorización otorgada.",
  "d)	Presentar ante la Superintendencia de Industria y Comercio (en adelante “SIC”) quejas por infracciones a lo dispuesto en la normatividad vigente.",
  "e)	Revocar la autorización y/o solicitar la supresión del dato, a menos que exista un deber legal o contractual que haga imperativo conservar la información.",
  "f)	Abstenerse de responder las preguntas sobre datos sensibles o sobre datos de las niñas y niños y adolescentes. Estos derechos los podré ejercer a través de los canales o medios dispuestos por Galilea para la atención al público, por el correo electrónico ayuda@galilea.co, cuya información puede consultar en galilea.co, para la atención de requerimientos relacionados con el tratamiento de mis datos personales y el ejercicio de los derechos mencionados en esta autorización. Por todo lo anterior, he otorgado mi consentimiento a Galilea, para que trate mi información personal de acuerdo con la Política de Privacidad y Tratamiento de Datos Personales dispuesta por la sociedad en galilea.co y que me dio a conocer antes de recolectar mis datos personales.",
];

export const kycs = [
  {
    title: "1.	Veracidad de la información: ",
    description:
      "Comparamos la información obtenida durante la solicitud de crédito con la información adquirida en bases de datos de terceros a los que Galilea accede legalmente y con esto, poder identificar las inconsistencias que existan.",
  },
  {
    title: "2.	Identificación de dirección de VPS: ",
    description:
      "Comparamos la dirección VPS con la dirección de residencia que nos provee las bases de datos externas.",
  },
  {
    title: "3.	Número móvil: ",
    description:
      "El número móvil del Usuario debe estar reportado en bases de datos externas y cumplir con una antigüedad mínima que demuestre su uso.",
  },
  {
    title: "4.	Firma electrónica: ",
    description:
      "La firma electrónica debe provenir del número móvil y correo electrónico verificado anteriormente, si el Usuario no adquirió la Firma Electrónica se tomará la validación que se realiza en notaria.",
  },
  {
    title: "5.	Cuenta bancaria: ",
    description:
      "La cuenta bancaria debe pertenecer al Usuario. Están restringidas algunas entidades bancarias que han presentado fallas en la validación de identidad conocidas previamente por Galilea.",
  },
  {
    title: "6. Otros: ",
    description:
      "Diferentes mecanismos de validación de identidad proporcionados por terceros que hacen parte del Know How de Galilea y que no pueden ser publicadas o puestas en conocimiento del público en general. ",
  },
];

export const contacts = [
  {
    title: "A.	Servicio al cliente:",
    value: "ayuda@galilea.co ",
  },
  {
    title: "B.	Cobranza",
    value: "ayuda@galilea.co ",
  },
  {
    title: "C.	PQRS",
    value: "ayuda@galilea.co",
  },
  {
    title: "D.	Correspondencia física",
    value: "Edificio Sibelius, Vereda Fagua, Sector La Caro Autopista Norte Chía, Cundinamarca",
  },
];

export const annexes = [
  "26.1.	Pagaré en blanco. ",
  "26.2.	Carta de Instrucciones.",
  "26.3.	Términos y Condiciones.",
  "26.4.	Política de tratamiento de datos personales.",
];

export function Intro() {
  return (
    <>
      <div className="pt-4">
        <span className="">
          El Deudor y Acreedor serán considerados en conjunto las “Partes” y de
          manera individual la “Parte”.{" "}
        </span>
      </div>
      <div className="pt-4">
        <span className="">
          Las Partes han decidido de manera libre y voluntaria suscribir el
          presente Contrato de Crédito (en adelante el “Contrato”), por medio
          del cual, se reglamenta la relación jurídica y comercial entre ellas.
          El Deudor manifiesta que conoce el contenido del presente documento,
          así como los Términos y Condiciones, los cuales hacen parte integral
          del presente Contrato. El Deudor manifiesta que ha recibido por parte
          de Galilea información veraz, oportuna, transparente, verificable,
          comprensible, precisa e idónea sobre los productos ofrecidos por
          Galilea, en el proceso de solicitud, aceptación y firma de los
          presentes documentos.
        </span>
      </div>
      <div className="pt-4">
        <span className="">
          Galilea no desarrolla actividades de intermediación o captación de
          dineros del público u otras actividades similares que sean privativas
          de las instituciones financieras. Del mismo modo,
        </span>
      </div>
    </>
  );
}

export function Product() {
  return (
    <>
      <div className="pt-4">
        <span className="">
          Galilea a través de su página web https://www.galilea.co dispone a
          favor del titular un crédito de bajo monto. Este crédito es informado
          de manera completa, veraz, transparente, oportuna, verificable,
          comprensible, precisa e idónea en cada una de las pestañas disponibles
          en la página web con las cuales el Usuario puede interactuar. Así
          mismo, el Usuario puede interactuar con el Calculador de crédito por
          medio del cual puede escoger el monto y elegir la fecha de pago del
          crédito. El Calculador del crédito no es una oferta de carácter
          comercial, simplemente corresponde a una forma adicional que dispone
          Galilea para que el Usuario conozca gráficamente la información del
          crédito solicitado.
        </span>
      </div>
      <div className="pt-4">
        <span className="">
          Galilea pone a disposición de los Usuarios un producto de crédito en
          el que el Usuario puede escoger el monto desde Doscientos mil pesos
          colombianos (COP$200.000) hasta Un millón quinientos mil de pesos
          colombianos (COP$1.500.000). El Usuario también puede escoger la fecha
          de pago, que por regla general coincide con un periodo de 8 a 40 días.
        </span>
      </div>
      <div className="pt-4">
        <span className="">
          Galilea a través del Calculador del crédito le informa al Usuario el
          monto solicitado, la fecha de pago, los intereses corrientes en
          términos de Efectivo Anual, el Costo opcional de Firma Electrónica e
          IVA en caso tal que aplique. Esta información el Usuario la puede
          consultar en todo el proceso de solicitud del crédito y realizar las
          modificaciones necesarias y pertinentes.
        </span>
      </div>
      <div className="pt-4">
        <span className="">
          Una vez Galilea recibe la solicitud del monto y plazo, realiza las
          validaciones de la información proporcionada por el Usuario, esta
          validación la puede realizar con terceros aliados tipo Buró de
          crédito, registraduría, entidades bancarias y determina de acuerdo al
          perfil de riesgo el monto del crédito. El monto de crédito es
          informado y aceptado por el Usuario.
        </span>
      </div>
      <div className="pt-4">
        <span className="">
          El Usuario tiene la obligación previo al desembolso del crédito de
          firmar los documentos que lo vinculan legal y contractualmente con
          Galilea. El Usuario puede realizar la firma a través de medios
          electrónicos (Firma Electrónica) o de manera física incorporando en
          los documentos impresos su rúbrica, si el Usuario decide optar por la
          firma física, deberá notarizar todos los documentos del crédito, este
          proceso es informado más adelante.
        </span>
      </div>
      <div className="pt-4">
        <span className="">
          Una vez el Usuario realiza la firma de los documentos del crédito,
          Galilea procede a iniciar el trámite de desembolso del crédito, el
          cual de acuerdo a nuestra promesa de valor corresponde a menos de 1
          día hábil posterior a la firma de los documentos del crédito. El
          desembolso puede verse afectado por razones externas a Galilea,
          correspondiente a la creación e inscripción de la cuenta bancaria,
          ciclos ACH o error en los datos proporcionados por el Usuario.
        </span>
      </div>
      <div className="pt-4">
        <span className="">
          Galilea no realiza captación de dineros del público o actividades
          consideradas privativas del sistema financiero. Razón por la cual,
          puede presentar casos de iliquidez que imposibiliten desembolsar los
          recursos al Usuario. Galilea se reserva el derecho de cancelar o no
          desembolsar el crédito por cualquier razón que considere pertinente
          sin necesidad de notificar previamente al Usuario. Galilea no utiliza
          intermediarios ni requiere el pago por anticipado de dineros para la
          solicitud del crédito, la solicitud del crédito y aprobación es 100%
          digital y el único proceso que puede ser suplido de manera física por
          parte del Usuario corresponde a la firma física del crédito.
        </span>
      </div>
      <div className="pt-4">
        <span className="">
          Galilea realiza el desembolso del crédito única y exclusivamente en la
          cuenta bancaria del Usuario, Galilea en ningún caso y bajo ninguna
          circunstancia realiza el desembolso del crédito en cuentas de terceras
          personas. Galilea desembolsa el valor total del monto solicitado por
          el Usuario, Galilea no retiene o descuenta del monto a desembolsar
          ningún costo opcional u obligatorio que deba asumir el Usuario.
        </span>
      </div>
    </>
  );
}

export function ProductContracted({
  creditUser,
  firmaElectronica,
  dctoFirmaElectronica,
  total
}) {
  const [conditions, setConditions] = useState([]);
  const [isLoading, setIsLoading] = useState(true);

  useEffect(() => {
    setConditions(getConditions(creditUser, dctoFirmaElectronica, firmaElectronica, total));
    setIsLoading(false);
  }, [creditUser, dctoFirmaElectronica, firmaElectronica, total]);

  if (isLoading) {
    return <div>Cargando datos...</div>
  }

  return (
    <>
      <div className="pt-4">
        <div>
          {conditions.map((condition, idx) => (
            <div
              key={'div-' + idx}
              className="flex gap-2 justify-between pt-2"
            >
              <div className="w-3/4" key={'title-' + idx}>{condition.title}</div>
              {condition.value ? (
                <div className="w-full" key={'value-' + idx}>{condition.value}</div>
              ) : (
                <div className="w-full" key={'number-' + idx}>
                  {condition.number === 0 ? (
                    (condition.number = "$0")
                  ) : (
                    <Numeral key={'numeral-' + idx} format={"$0,0"} value={condition.number} />
                  )}
                </div>
              )}
            </div>
          ))}
        </div>
      </div>
    </>
  );
}

export function Requirements() {
  return (
    <>
      <div className="pt-4">
        <span className="">
          El Usuario ha cumplido con los requisitos establecidos por Galilea en
          sus políticas de crédito, esto es que para acceder a los productos
          ofertados por Galilea, el Usuario:
        </span>
      </div>
      <div className="pt-4">
        {requirements.map((requirement) => (
          <div key={requirement}>{requirement}</div>
        ))}
      </div>
      <div className="pt-4">
        <span className="">
          Sin perjuicio de lo anterior, Galilea podrá realizar validaciones y
          verificaciones de cada uno de estos requisitos, así como requisitos
          adicionales establecidos en su modelo de decisión, en caso que Galilea
          determine que puede existir inexactitud, error o información falsa en
          el proceso de solicitud del Crédito, aprobación o desembolso,
          procederá a rechazar de plano el crédito y por ende no desembolsará el
          dinero solicitado, sin que por este hecho se genere algún tipo de
          sanción o penalidad para Galilea. El Usuario es el único responsable
          por la exactitud de la información proporcionada.
        </span>
      </div>
    </>
  );
}

export function Responsabilities() {
  return (
    <>
      <div className="pt-4">
        <span className="">
          El Usuario tiene la obligación previo al desembolso del crédito de
          firmar los documentos que lo vinculan legal y contractualmente con
          Galilea. El Usuario puede realizar la firma a través de medios
          electrónicos (Firma Electrónica) o de manera física incorporando en
          los documentos impresos su rúbrica, si el Usuario decide optar por la
          firma física, deberá notarizar todos los documentos del crédito, este
          proceso es informado más adelante.
        </span>
      </div>
      <div className="pt-4">
        <span className="">
          Una vez el Usuario realiza la firma de los documentos del crédito,
          Galilea procede a iniciar el trámite de desembolso del crédito, el
          cual de acuerdo a nuestra promesa de valor corresponde a menos de 1
          día hábil posterior a la firma de los documentos del crédito. El
          desembolso puede verse afectado por razones externas a Galilea,
          correspondiente a la creación e inscripción de la cuenta bancaria,
          ciclos ACH o error en los datos proporcionados por el Usuario. El
          costo de la Firma Electrónica es opcional y podrás elegir asumir este
          servicio o describirlo y optar por el proceso de firma física, tal
          como se indica en el numeral 2.2.
        </span>
      </div>
    </>
  );
}

export function SignE() {
  return (
    <>
      <div className="pt-4">
        <span className="">
          Galilea pone a disposición del Usuario directamente o por intermedio
          de terceros la posibilidad de firmar los documentos del crédito a
          través de medios electrónicos. El procedimiento de firma electrónica
          consiste en la posibilidad de firmar los documentos de crédito
          posterior a la solicitud y aprobación del crédito. El procedimiento
          consiste en el envío de un{" "}
          <span className="italic font-bold">Código One Time Password</span> de
          6 dígitos al número de celular y correo electrónico del Usuario, este
          procedimiento se encuentra reglamentado de conformidad con el Decreto
          2364 de 2012, el artículo 7 de la Ley 527 de 199, y el artículo 244
          del Código General del Proceso, normas que indican que los documentos
          en forma de mensaje de datos se presumen auténticos.
        </span>
      </div>
      <div className="pt-4">
        <span className="">
          Además, establecen que la firma electrónica se encuentra conformada
          por métodos tales como códigos, contraseñas, datos biométricos, o
          claves criptográficas privadas, que permiten identificar a una
          persona, en relación con un mensaje de datos. Lo anterior, siempre y
          cuando el mismo sea confiable y apropiado respecto de los fines para
          los que se utiliza la firma, atendidas todas las circunstancias del
          caso, así como cualquier acuerdo pertinente, en los términos de la
          norma citada. El costo del servicio de Firma Electrónica es un costo
          fijo de COP$145.000 CIENTO CUARENTA Y CINCO MIL PESOS COLOMBIANOS el
          cual puede tener o no un descuento por pronto pago, en caso de que
          entres en mora este descuento puede cambiar o anularse.
        </span>
      </div>
      <div className="pt-4">
        <span className="">
          Recuerda que el cobro de la firma electrónica es opcional y no se
          causará en caso de que no desees usarla.
        </span>
      </div>
    </>
  );
}

export function SignM() {
  return (
    <>
      <div className="pt-4">
        <span className="">
          El Usuario de manera libre y voluntaria, de acuerdo a su libertad de
          escogencia contractual puede firmar de manera física los documentos
          del crédito. Razón por la cual, Galilea, ha dispuesto para el titular
          que no desee suscribir los documentos a través de la firma
          electrónica, un canal adicional para realizar la firma del crédito
          mediante el envío de la siguiente documentación a la dirección de
          correspondencia física Cl 79 No. 11 66 Ed Spaces o a la dirección
          electrónica de manera escaneada al correo electrónico
          ayuda@galilea.co, si los documentos son enviados a la dirección física
          o electrónica deben estar autenticados por notaria. Los documentos que
          debe enviar el Usuario son:
        </span>
      </div>
      {documents.map((document) => (
        <div key={document} className="pt-4">
          <span className="">{document} </span>
        </div>
      ))}
      <div className="pt-4">
        <span className="">
          El Usuario se obliga a suministrar información veraz, completa,
          actualizada y comprobable, así mismo, este deberá garantizar que a
          partir de los datos suministrados no busca inducir al error en los
          procesos internos, para lo cual, Galilea en procura de la veracidad
          realizará las rectificaciones respectivas siendo estas últimas de
          pleno conocimiento del Usuario.
        </span>
      </div>
    </>
  );
}

export function Disbursement() {
  return (
    <>
      <div className="pt-4">
        <span className="">
          Galilea realizará el desembolso del crédito una vez se haya realizado
          la suscripción por parte del Usuario de los documentos del crédito.
          Galilea verifica con el banco la titularidad de la cuenta bancaria
          proporcionada por el Usuario. El crédito se desembolsará en los
          tiempos y condiciones indicados en el numeral 2 del presente
          documento. El crédito se desembolsará por medio de{" "}
          <span className="italic">Automated Clearing House</span> (ACH por sus
          siglas en inglés), es por esto que al ser un tercero, Galilea se
          vincula a sus términos y condiciones, así mismo a las restricciones de
          horario. Este proceso puede tardar hasta 1 día hábil siguiente a la
          aceptación del contrato.
        </span>
      </div>
      <div className="pt-4">
        <span className="">
          Las solicitudes iniciadas el fin de semana se gestionan a partir del
          primer día hábil siguiente. Si la cuenta bancaria no es válida, el
          banco nos notificará previamente dentro del siguiente día hábil.
        </span>
      </div>
      <div className="pt-4">
        <span className="">
          Galilea se reserva el derecho de solicitar documentos que sean
          necesarios para corroborar información, aún después de aprobado el
          crédito y en general, a negar o retener el desembolso en caso de
          identificar alguna actividad sospechosa antes, durante y después de
          aprobado y firmado documentos del crédito.
        </span>
      </div>
      <div className="pt-4">
        <span className="">
          En caso de iliquidez de capital para desembolsar, Galilea podrá
          cancelar a su arbitrio los créditos pendientes de desembolso, sin
          requerir informar previamente al Usuario sin que con esto se genere
          sanción o penalización para Galilea.
        </span>
      </div>
      <div className="pt-4">
        <span className="">
          El Usuario autoriza por su cuenta y riesgo, que el desembolso se
          realice a través de giros a terceros, a través de convenios presente o
          futuros que pueda suscribir Galilea. El Usuario será el único
          responsable del cobro de los valores girados, y que cumplirá por su
          cuenta, con las medidas de identificación y conocimiento de cliente
          exigidas por el comercio o por el operador de servicios de giros
          autorizados.
        </span>
      </div>
    </>
  );
}

export function Authorizations() {
  return (
    <>
      <div className="pt-4">
        <span className="">
          El Usuario autoriza expresamente a Galilea para que en su nombre y
          representación ejerza las siguientes atribuciones, así mismo, autoriza
          de manera expresa a Galilea o a las personas que hagan sus veces, a:
        </span>
      </div>
      {authorizations.map((authorization) => (
        <div key={authorization} className="pt-4">
          <span className="">{authorization} </span>
        </div>
      ))}
    </>
  );
}

export function Constitution() {
  return (
    <>
      <div className="pt-4">
        <span className="">
          El Usuario constituirá a favor de Galilea una garantía, consistente en
          un pagaré en blanco junto con su carta de instrucciones. Por medio de
          esta garantía el Usuario ofrece todos sus bienes presentes y futuros
          para garantizar el cumplimiento de su obligación. La constitución del
          pagaré en blanco busca asegurar la satisfacción del acreedor que
          obtiene la facultad para cobrar lo que se le debe a través de cobros
          coactivos o ejecutivos. El acreedor podrá ceder a favor de un tercero
          los derechos derivados del pagaré quien también tendrá la facultad de
          cobrar ejecutivamente el monto garantizado.
        </span>
      </div>
    </>
  );
}

export function CurrentInterest() {
  return (
    <>
      <div className="pt-4">
        <span className="">
          Todo Usuario que adquiera un crédito con Galilea, deberá pagar a favor
          de esta el interés remuneratorio establecido en el numeral 1.1. del
          presente documento. Este interés remuneratorio retribuye o compensa el
          costo del dinero prestado durante el tiempo en el cual el acreedor no
          lo tiene a disposición y envuelve el beneficio, ventaja o provecho del
          deudor por tal virtud y el riesgo del crédito de incumplimiento.
        </span>
      </div>
      <div className="pt-4">
        <span className="">
          La tasa de interés remuneratorio puede variar mes a mes, Galilea
          siempre te informará a través de su página web la tasa máxima legal
          vigente y la tasa que le cobra a sus clientes en términos de Efectivo
          Anual. Galilea siempre cobrará su interés por debajo de la máxima
          permitida y estipulada por la autoridad nacional.
        </span>
      </div>
    </>
  );
}

export function DefaultInterest() {
  return (
    <>
      <div className="pt-4">
        <span className="">
          Todo Usuario que adquiera un crédito con Galilea e incurra en mora, es
          decir, no pague su crédito en la fecha acordada, deberá pagar como
          interés moratorio a favor de Galilea la tasa máxima legal permitida
          informada en la página web de Galilea y en el numeral 1.1 del presente
          documento. Este interés es diferente al remuneratorio, en virtud que
          la vocación del interés moratorio consiste en el carácter punitivo o
          resarcitorio, los cuales representan indemnización de los perjuicios
          ocasionados por el incumplimiento o la tardanza del cumplimiento de la
          obligación por parte del deudor. Estos intereses a diferencia de los
          gastos de cobranza se causan de pleno derecho, desde el momento de la
          mora en la obligación de restitución y son exigibles junto con la
          obligación de restitución del dinero mutuado y se deben mientras
          perduren la mora.
        </span>
      </div>
      <div className="pt-4">
        <span className="">
          Así las cosas, los intereses moratorios se causarán a partir de la
          mora en el cumplimiento de la obligación principal por parte del
          deudor, por lo cual, tu como deudor pagarás los intereses de mora
          correspondientes a los días adicionales en los que te demores
          realizando el pago, a tasa moratoria máxima permitida en Colombia.
        </span>
      </div>
      <div className="pt-4">
        <span className="">
          El costo opcional del servicio de Firma Electrónica al no ser un
          servicio vinculado con el crédito no se tendrá en cuenta para el
          cálculo de los intereses moratorios, así mismo, no se entenderá como
          un rubro asociado al crédito y no computará como interés. Galilea no
          cobra intereses sobre intereses, el cálculo de los intereses de mora
          corresponde al capital, sin tener en cuenta para el cálculo de estos
          los intereses remuneratorios causados u otros servicios adquiridos por
          el Usuario.
        </span>
      </div>
    </>
  );
}

export function Expiration() {
  return (
    <>
      <div className="pt-4">
        <span className="">
          Tu como Usuario de Galilea y deudor, autorizas a Galilea a declarar de
          manera automática el vencimiento del contrato de mutuo. Galilea en
          virtud del vencimiento del contrato podrá implementar de manera
          inmediata la exigibilidad de todas las obligaciones vigentes a tu
          cargo. Así mismo, Galilea en virtud de la presente autorización podrá
          acelerar y declarar el vencimiento de los plazos de tu obligación o de
          las cuotas pendientes de pago, estén o no vencidas, y exigir el pago
          total e inmediato judicial o extrajudicialmente en los siguientes
          casos:
        </span>
      </div>
      {expirations.map((expiration) => (
        <div key={expiration} className="pt-4">
          <span className="">{expiration} </span>
        </div>
      ))}
    </>
  );
}

export function Notification() {
  return (
    <>
      <div className="pt-4">
        <span className="">
          En virtud del presente documento, autorizo, acepto, estoy notificado y
          otorgo mi consentimiento para que Galilea en su condición de acreedor
          pueda ceder su posición como tal, a favor de uno o varios terceros.
          Galilea si así lo considera podrá notificarme de la cesión por
          cualquier medio de contacto autorizado en el presente documento o en
          el formulario de solicitud y aprobación del crédito. Así mismo,
          autorizo que con la cesión que pueda realizar Galilea a favor de uno o
          varios terceros, se comparta mi información personal, tal como lo
          indique en la Cláusula cuarta del presente documento. El tercero al
          que se le cede, cuenta con las mismas facultades, derechos y
          obligaciones de Galilea.
        </span>
      </div>
    </>
  );
}

export function MethodPayment() {
  return (
    <>
      <div className="pt-4">
        <span className="">
          El Usuario podrá utilizar cualquier plataforma especializada en
          recaudos, pagos y giros a nivel nacional, siempre que Galilea tenga
          convenio con dichas entidades. El Usuario tiene el deber de diligencia
          de conocer los canales autorizados por Galilea para efectuar el pago
          de su crédito, es por lo anterior, que el Usuario debe ingresar a su
          cuenta Galilea a través de un clic en “pagar mi cuota”, ingresa el
          número de documento, validar el{" "}
          <span className="font-bold italic">reCATCHA</span> y recibe el código
          de verificación a través de WhatsApp o Email, una vez ingresa, el
          Usuario debe elegir alguno de nuestros canales físicos o electrónicos
          para efectuar el pago de su cuota o crédito.
        </span>
      </div>
      <div className="pt-4">
        <span className="">
          El Usuario para quedar a paz y salvo con su obligación debe efectuar
          el pago a través del procedimiento indicado anteriormente. Galilea no
          se hace responsable si el Usuario efectúa el pago en una cuenta o
          convenio diferente a los informados en su página web.
        </span>
      </div>
    </>
  );
}

export function AdvancePayment() {
  return (
    <>
      <div className="pt-4">
        <span className="">
          El Usuario está facultado y tiene derecho a efectuar pagos anticipados
          de las cuotas o saldos en forma total o parcial. En caso que el
          Usuario decida efectuar pagos anticipados totales o parciales deberá
          pagar los intereses y los cargos opcionales en proporción con el
          periodo de realización del pago.
        </span>
      </div>
      <div className="pt-4">
        <span className="">
          Los pagos anticipados que realice el Usuario serán abonados de la
          siguiente forma, salvo manifestación en contrario:
        </span>
      </div>
      {advances.map((advance) => (
        <div key={advance} className="pt-4">
          <span className="">{advance} </span>
        </div>
      ))}
      <div className="pt-4">
        <span className="">
          Galilea, no exigirá el pago de interés no causado, ni sanciones
          económicas por el pago anticipado de su obligaciones.
        </span>
      </div>
    </>
  );
}

export function Retract() {
  return (
    <>
      <div className="pt-4">
        <span className="">
          El Usuario podrá en ejercicio de su derecho al retracto solicitar el
          desistimiento del crédito requerido, dentro de los cinco (5) días,
          contados a partir de la aprobación del crédito. El Usuario deberá
          realizar la devolución del capital desembolsado en las mismas
          condiciones dentro del tiempo indicado anteriormente.
        </span>
      </div>
      <div className="pt-4">
        <span className="">
          Así mismo, el Usuario deberá asumir el costo opcional de Firma
          Electrónica, si este fue adquirido por él, en virtud que es un
          servicio independiente al crédito y de acuerdo con la legislación
          colombiana el mismo ya fue consumido por parte del Usuario y no
          aplicaría sobre este rubro el derecho de retracto. El valor de la
          Firma Electrónica es de: COP$145.000 CIENTO CUARENTA Y CINCO MIL PESOS
          COLOMBIANOS.
        </span>
      </div>
    </>
  );
}

export function Debit({
  basicInfo
}) {
  return (
    <>
      <div className="pt-4">
        <span className="">
          A través del presente documento, el Usuario otorga de manera clara,
          expresa y previa autorización específica para que Galilea efectúe
          débitos automáticos a mi cuenta bancaria donde se realizó el
          desembolso del crédito o cualquier cuenta bancaria conocida por parte
          de Galilea dentro de la red bancaria. Esta autorización se extiende
          también a billeteras digitales, tales como Nequi, Daviplata o cuentas
          bancarias o billeteras digitales existentes o futuras.
        </span>
      </div>
      <div className="pt-4">
        <span className="">
          La autorización consiste en que Galilea o sus aliados, podrán efectuar
          desde el primer día de mora operativizar el débito automático de la
          totalidad o parte del monto adeudado, así como del costo del servicio
          de Firma Electrónico, si este servicio fue adquirido. La cuenta
          bancaria sobre la cual podrán efectuar la operatividad del crédito
          consiste en:
        </span>
      </div>
      <div className="pt-4 font-bold">
        <div className="flex gap-2">
          <div>Entidad bancaria:</div>
          <div>{basicInfo?.bankAccount}</div>
        </div>
        <div className="flex gap-2">
          <div>Número de cuenta:</div>
          <div>{basicInfo?.accountNumber}</div>
        </div>
      </div>
      <div className="pt-4">
        <span className="">
          Así mismo, Galilea y sus aliados podrán efectuar el débito en
          cualquier cuenta bancaria que conozcan de las cuales el Usuario es
          titular, en caso tal que de la cuenta indicada anteriormente no
          existan fondos suficientes o que se haya efectuado débitos de manera
          parcial por no haber depósitos suficientes. Galilea podrá seguir
          intentando procedimientos de débito automático en la cuentas bancarias
          hasta la recuperación completa de tus obligaciones.
        </span>
      </div>
      <div className="pt-4">
        <span className="">
          La presente autorización es permanente e irrevocable, mientras
          subsista la obligación referenciada. Galilea se reserva el derecho de
          aplicar el débito automático en la fecha fijada como vencimiento y
          hacer exigible el pago de la obligación desde el primer día de mora,
          en el caso que no se evidencie el pago voluntario por parte del
          Usuario.
        </span>
      </div>
    </>
  );
}

export function Collection() {
  return (
    <>
      <div className="pt-4">
        <span className="">
          El usuario reconocerá y pagará a favor de Galilea (acreedor), además
          de los intereses moratorios que se causen por la mora, los gastos de
          cobranza por incumplimiento del contrato de mutuo. Galilea dejará
          constancia de la acción de cobranza desplegada con el objetivo de
          liquidar los gastos de cobranza imputables al Usuario, así como los
          impuestos que deberá asumir.
        </span>
      </div>
      <div className="pt-4">
        <span className="">
          Galilea no aplica costos automáticos por el hecho de presentarse la
          mora, razón por la cual, el costo de gasto de cobranza es proporcional
          a las gestiones de cobro realizadas con el fin de cobrar los costos en
          que incurre Galilea o el acreedor para la realización de las gestiones
          de cobranza a través de empleados contratados para tal fin o firmas
          externas especializadas.
        </span>
      </div>
      <div className="pt-4">
        <span className="">
          Esta gestión de cobro pre-jurídico por parte de Galilea comienza desde
          la fecha de vencimiento de la obligación y consiste en contactar e
          informar al Usuario acerca del estado de las obligaciones a través de
          diversos medios de contacto, tales como, pero sin limitarse a:
        </span>
      </div>
      {collections.map((collection) => (
        <div key={collection} className="pt-4">
          <span className="">{collection} </span>
        </div>
      ))}
      <div className="pt-4">
        <span className="">
          Galilea conservará en medios verificables los soportes de la gestión
          de cobranza, así como los intentos de contacto o contactos. Todas las
          llamadas en el proceso de cobranza podrán ser grabadas y las mismas
          podrán ser conservadas junto con los registros que contengan la
          información de la persona que realiza el cobro, la fecha, hora y
          resumen de lo hablado, que podrá ser usadas como prueba de los
          compromisos adquiridos y de la calidad de las llamadas dentro de los
          estándares sugeridos por el regulador nacional.
        </span>
      </div>
    </>
  );
}

export function Report({
  userInfo
}) {
  return (
    <>
      <div className="pt-4">
        <span className="">
          El Usuario autoriza a Galilea a que reporte, a más tardar 20 días
          después del incumplimiento como deudor a las Centrales de Riesgo o de
          Información Crediticia o Financiera, sujetándose a lo previsto en la
          legislación sobre habeas data. Así las cosas, Galilea te notificara el
          reporte negativo con la anticipación ordenada por la legislación
          nacional para los eventos en mora, para lo cual, desde ya, autorizas
          para que dicha notificación sea practicada mediante comunicación
          dirigida a tu domicilio o cualquier tipo de mensaje de datos,
          incluyendo SMS, correo electrónico o cualquier medio que quede
          registro para posteriores consultas.
        </span>
      </div>
      <div className="pt-4">
        <span className="">
          El Usuario como deudor autoriza de manera expresa e irrevocable a que
          Galilea o a quien represente sus derecho u ostente en el futuro la
          calidad de acreedor, pueda consultar, reportar, actualizar, solicitar,
          compartir y divulgar a las centrales de riesgo como DataCredito
          (Experian) o Trans Union (Cifin) o cualquier otra entidad que maneje o
          administre bases de datos con los mismos fines, toda la información
          referente al comportamiento crediticio. En este sentido, el Usuario
          como deudor autoriza la notificación en cualquiera de los siguientes
          canales:
        </span>
      </div>
      <div className="pt-4 font-bold">
        <div className="flex gap-2">
          <div>Teléfono celular:</div>
          <div>{userInfo?.phone}</div>
        </div>
        <div className="flex gap-2">
          <div>Correo electrónico:</div>
          <div>{userInfo?.email}</div>
        </div>
      </div>
      <div className="pt-4">
        <span className="">
          La presente autorización se realiza en concordancia con el inciso 2
          del artículo 2.2.2.28.2 del Decreto 1074 de 2015, el cual establece
          que la fuentes de la información podrán pactar con los titulares,
          otros mecanismo mediante los cuales se dé cumplimiento al enviado de
          la comunicación en mención, los cuales podrán consistir, entre otros,
          en cualquier tipo de mensajes de datos, siempre que se ajusten a lo
          previsto en la Ley 527 de 1999. De igual forma, el literal b) del
          numeral 1.3.6 del Título V de la Circular Única de la Superintendencia
          de Industria y Comercio, contempla que se utilicen otros mecanismos
          para la remisión de la comunicación previa al reporte a las Operadoras
          de información, siempre que pueda comprobarse que la fuente acordó
          previamente con el titular un mecanismo diferente para informar sobre
          el eventual reporte negativo.
        </span>
      </div>
      <div className="pt-4">
        <span className="">
          Conforme a lo anterior, entre Galilea y el Usuario se pacta de manera
          clara, expresa y mutua, que la notificación previa al reporte negativo
          se llevará a cabo por cualquiera de los canales establecidos
          anteriormente autorizados por el Usuario.
        </span>
      </div>
    </>
  );
}

export function Extend() {
  return (
    <>
      <div className="pt-4">
        <span className="">
          Tu como Usuario podrás novar tu crédito con Galilea por un crédito
          nuevo. Este nuevo crédito tendrá el plazo máximo indicado en el
          crédito inicial. Para novar el crédito, se debe cerrar la obligación
          anterior, razón por la cual, el Usuario deberá pagar los intereses
          remuneratorios causados, así como el costo de Firma Electrónica en
          caso de haber sido adquirida por parte de él.
        </span>
      </div>
      <div className="pt-4">
        <span className="">
          Para la expedición del nuevo crédito, el Usuario podrá firmar los
          documentos nuevamente a través de la Firma Electrónica o de manera
          física y la constitución de un nuevo pagaré en blanco junto con la
          respectiva carta de instrucciones. Al ser un crédito nuevo el Usuario
          deberá reconocer los intereses remuneratorios que se causen y tendrá
          las mismas obligaciones del crédito anterior, las cuales se
          encontrarán regladas en un contrato de mutuo nuevo.
        </span>
      </div>
      <div className="pt-4">
        <span className="">
          El procedimiento para novar la obligación se lleva a cabo a través de
          nuestra página web, de acuerdo a los pasos indicado en la misma, te
          solicitamos leer cuidadosamente las condiciones para novar y si puedes
          aplicar a este servicio opcional.
        </span>
      </div>
      <div className="pt-4">
        <span className="">
          Por parte de Galilea, te solicita cumplir con tus obligaciones a
          tiempo, en virtud que realizar la novación o incurrir en mora puede
          incrementar el valor de tu crédito.
        </span>
      </div>
    </>
  );
}

export function Indebtedness() {
  return (
    <>
      <div className="pt-4">
        <span className="">
          Le corresponde a los Usuarios de Galilea ser conscientes de sus
          obligaciones financieras adquiridas con terceros. Galilea le
          recomienda que no realice la solicitud del crédito si se encuentra
          sobreendeudado. Por parte de Galilea se cuenta con filtros que le
          permiten identificar si un Usuario está sobreendeudado y proceder con
          la cancelación de la solicitud del crédito y por ende no proceder con
          la aprobación y desembolso del mismo. Los Usuarios de Galilea a través
          del formulario de solicitud del crédito manifiestan sus ingresos
          mensuales así como sus egresos y Galilea procede a verificar dicha
          información a través de bases de datos de terceros.
        </span>
      </div>
      <div className="pt-4">
        <span className="">
          Galilea realiza una evaluación del perfil de riesgo de incumplimiento
          por parte del Usuario y conforme a sus políticas de riesgo acepta o
          rechaza la solicitud del crédito del Usuario. Los costos por utilizar
          los servicios de Galilea son informados de manera clara, expresa,
          transparente, idónea y comprensible de acuerdo a lo estipulado en la
          legislación colombiana y el Usuario de manera libre y voluntaria
          realiza la evaluación de su capacidad de endeudamiento con Galilea.
        </span>
      </div>
    </>
  );
}

export function Founds() {
  return (
    <>
      <div className="pt-4">
        <span className="">
          Galilea manifiesta que sus fondos y recursos no provienen de
          actividades ilícitas, ni del ejercicio directo o indirecto de
          actividades establecidas como ilícitas bajo los términos de la ley
          penal colombiana. Así mismo, el Usuario manifiesta que los fondos
          desembolsados por Galilea no serán utilizados para actividades
          ilícitas o delictivas, así como los fondos con los cuales pagará sus
          obligaciones no provienen de actividades ilícitas.
        </span>
      </div>
      <div className="pt-4">
        <span className="">
          El Usuario otorga autorización a Galilea para que sus datos personales
          sean consultados y verificados en listas de riesgos y portales de
          información pública nacionales o internacionales, para la
          administración del riesgo del Sistema de Administración del Riesgo de
          Lavado de Activos, Financiación del Terrorismo y de la Proliferación
          de Armas de Destrucción Masiva y otros riesgos asociados. Galilea está
          facultada para realizar reportes correspondientes a las autoridades
          naciones competentes en materia de lavado de activos y financiación
          del terrorismo, que considere necesarios realizar de conformidad con
          sus reglamentos y manuales de riesgo.
        </span>
      </div>
      <div className="pt-4">
        <span className="">
          Esta autorización se extiende durante la totalidad del tiempo en el
          que pueda llegar a consolidarse un vínculo o persista por cualquier
          circunstancia entre Galilea y el Usuario, y con posterioridad a la
          terminación del mismo, siempre que tal tratamiento se encuentre
          relacionado con las finalidades para las cuales los datos fueron
          inicialmente suministrado.
        </span>
      </div>
    </>
  );
}

export function PersonalData() {
  return (
    <>
      <div className="pt-4">
        <span className="">
          Galilea realiza el tratamiento de los datos personales de sus Usuarios
          en concordancia con lo dispuesto en la Ley 1581 de 2012, Ley 1266 de
          2008, decretos reglamentarios y todas las normas referentes al
          tratamiento de datos personales en Colombia. El Usuario tiene derecho
          a conocer, actualizar y rectificar su información personal en
          cualquier momento.
        </span>
      </div>
      <div className="pt-4">
        <span className="">
          Galilea será el Responsable del tratamiento de datos personales y, en
          tal virtud, podrá recolectar, almacenar, usar, consultar, reportar
          ante las centrales de riesgo financieras y terceros la información
          recolectada del Usuario. El tratamiento que efectúe Galilea cumplirá
          con las siguientes finalidades:
        </span>
      </div>
      {personals.map((personal) => (
        <div key={personal} className="pt-4">
          <span className="">{personal} </span>
        </div>
      ))}
    </>
  );
}

export function Rights() {
  return (
    <>
      <div className="pt-4">
        <span className="">
          Los derechos del Usuario como titular de los datos son los previstos
          en la Constitución Política de Colombia, la Ley 1266 de 2008 y en la
          Ley 1581 de 2012, especialmente los siguientes:
        </span>
      </div>
      {rights.map((right) => (
        <div key={right} className="pt-4">
          <span className="">{right} </span>
        </div>
      ))}
      <div className="pt-4">
        <span className="">
          Manifiesto que la presente autorización me fue solicitada y puesta de
          presente antes de entregar mis datos y que la suscribo de forma libre
          y voluntaria una vez leída en su totalidad.
        </span>
      </div>
    </>
  );
}

export function Place() {
  return (
    <>
      <div className="pt-4">
        <span className="">
          El presente Contrato se celebra en la ciudad de Bogotá D.C., y la
          legislación aplicable a la interpretación y ejecución del mismo es la
          ley Colombiana.
        </span>
      </div>
    </>
  );
}

export function KYC() {
  return (
    <>
      <div className="pt-4">
        <span className="">
          Galilea ha desarrollado protocolos de prevención al fraude y falsedad
          personal buscando proteger la información del Usuario para lo cual ha
          creado validaciones de seguridad que se describen a continuación:
        </span>
      </div>
      {kycs.map((kyc) => (
        <div key={kyc.title} className="pt-4">
          <span className="">
            <span className="font-bold">{kyc.title} </span>
            {kyc.description}
          </span>
        </div>
      ))}
    </>
  );
}

export function Verify() {
  return (
    <>
      <div className="pt-4">
        <span className="">
          Mediante la aceptación de los presentes términos y condiciones y la
          suscripción del contrato de crédito, el Usuario declara que la
          información compartida con Galilea es completa, actual y veraz,
          resultando de su entera responsabilidad cualquier disconformidad entre
          los datos entregados y la realidad, bajo la premisa que en tal caso
          podría convertirse en autor de los delitos de estafa, falsedad en
          documento privado y/o falsedad personal los cuales se encuentran
          penalizados de acuerdo con lo establecido al respecto por los
          artículos 246, 289 y 296 del Código Penal Colombiano. Así mismo, el
          Usuario declara que los recursos solicitados y objeto del contrato
          serán usados para ﬁnes lícitos y de ninguna manera para la comisión de
          cualquiera de los actos establecidos como delitos de acuerdo con la
          misma legislación penal colombiana.
        </span>
      </div>
    </>
  );
}

export function Damages() {
  return (
    <>
      <div className="pt-4">
        <span className="">
          En adición a las sanciones penales a las que el titular puede verse
          involucrado por los delitos mencionados en el parágrafo anterior, en
          caso de no brindar a Galilea información real y veraz, o no
          actualizarla dentro del transcurso de la vigencia de la relación
          comercial, se causen perjuicios a Galilea que, para efectos de su
          tasación inicial y en adición a todos aquellos perjuicios que se
          establezcan dentro del proceso judicial correspondiente, ascienden
          valor correspondiente al cien por ciento (100%) de la suma adeudada
          por cualquier concepto más los impuestos generados por este concepto.
        </span>
      </div>
      <div className="pt-4">
        <span className="">
          Los perjuicios aquí estimados podrán ser cobrados junto con el
          capital, intereses remuneratorios, intereses de mora y demás gastos,
          incluidos los de cobranza, que surjan de la obligación bajo el
          entendido que los perjuicios aquí indicados y los otros cobros
          señalados no resultan incompatibles al tener surgimiento en dos
          situaciones perfectamente distinguibles, los unos de la falta de
          veracidad o actualidad de la información y los otros del contrato
          celebrado y sus costos conexos.
        </span>
      </div>
    </>
  );
}

export function Tx() {
  return (
    <>
      <div className="pt-4">
        <span className="">
          El Usuario entiende y acepta que el presente documento se entiende
          como formulario de vinculación a los servicios de Galilea y que cada
          vez que haya una modificación en el monto o plazo del crédito, o demás
          aspectos del presente acuerdo, las modificaciones, adiciones o
          supresión de información, serán comunicadas de manera previa al
          Usuario y se entenderán aceptadas con la utilización de cualquiera de
          nuestros servicios, a partir de la fecha de entrada en vigor.
        </span>
      </div>
      <div className="pt-4">
        <span className="">
          No obstante, las modificaciones que se realicen, por los servicios y
          montos de crédito suscritos con anterioridad se mantendrán las
          condiciones establecidas al momento de su aprobación. La aceptación de
          manera voluntaria e inequívoca de los presentes Términos y
          Condiciones, al presionar el botón “acepto” el Usuario confirma haber
          leído y estar de acuerdo con los mismos, lo cual le permite continuar
          con la solicitud del crédito correspondiente, constituyéndose de esta
          manera la aceptación clara y expresa al tratamiento de la información
          personal y las reglas de operación de Galilea, de acuerdo con lo
          establecido.
        </span>
      </div>
    </>
  );
}

export function Contact() {
  return (
    <>
      <div className="pt-4">
        <span className="">
          El Usuario, podrá ejercer su derecho de información respecto al
          crédito a su cargo y a interponer peticiones, quejas y reclamos por
          las condiciones que considere necesarias y pertinentes, en los
          siguientes canales:
        </span>
      </div>
      {contacts.map((contact) => (
        <div key={contact.title} className="pt-4">
          <div>{contact.title} </div>
          <div className="font-bold">{contact.value} </div>
        </div>
      ))}
      <div className="pt-4">
        <span className="">
          Galilea se compromete a efectuar la debida comunicación a los
          titulares de la información, cualquier modificación, adición o
          supresión de los presentes términos y condiciones y la fecha de
          entrada en vigor.
        </span>
      </div>
    </>
  );
}

export function Annexes() {
  return (
    <>
      {annexes.map((annexe) => (
        <div key={annexe} className="pt-4">
          <span className="">{annexe} </span>
        </div>
      ))}
    </>
  );
}
